import {
  CHANGE_CREDENTIAL_CATEGORY,
  CHANGE_CREDENTIAL_FILTER,
  CHANGE_CREDENTIAL_SIDEBAR,
  LOAD_CREDENTIALS,
  TOGGLE_CREDENTIAL_FORM,
  TOGGLE_CREDENTIAL_VIEW,
  TOGGLE_MODERATE_FORM,
  SET_MODERATED_COUNT,
  CHANGE_CREDENTIAL_FILTERS,
} from 'constants/ActionTypes';
import { getIntlMessage } from 'helpers/utilHelpers';
import { loadCredentialsSuccess } from 'actions/entities/credentialActions';
import { getSearch, getSortingByKey } from 'selectors/settingsSelectors';
import { getCredentialListFilters } from 'selectors/ui/credentialListSelectors';
import { CREDENTIAL_LIST } from 'constants/SettingConstants';

// Handles credential view modal
export const toggleCredentialView = (credentialId = null) => {
  return {
    type: TOGGLE_CREDENTIAL_VIEW,
    credentialId,
  };
};

// Handles credential form modal
export const toggleCredentialForm = (credentialId = null) => {
  return {
    type: TOGGLE_CREDENTIAL_FORM,
    credentialId,
  };
};

// Handles credential form modal
export const toggleModarateForm = (credentialId = null) => {
  return {
    type: TOGGLE_MODERATE_FORM,
    credentialId,
  };
};

// Handles changing of the credentials page sidebar
export const changeCredentialsSidebar = (collapsed) => {
  return {
    type: CHANGE_CREDENTIAL_SIDEBAR,
    collapsed,
  };
};

// Handles changing of the credentials page filter
export const changeCredentialsFilter = (filter) => {
  return {
    type: CHANGE_CREDENTIAL_FILTER,
    filter,
  };
};

// Handles changing of the credentials page all filters
export const changeCredentialsFilters = (values) => {
  return {
    type: CHANGE_CREDENTIAL_FILTERS,
    values,
  };
};

// Handles changing of the credentials page category
export const changeCredentialsCategory = (category) => {
  return {
    type: CHANGE_CREDENTIAL_CATEGORY,
    category,
  };
};

// Begin loading of the credentials list
export const loadCredentialList = (page, onLoading) => {
  return {
    type: LOAD_CREDENTIALS,
    payload: {
      extraFields: ['projectName', 'projectStatus', 'group'],
      page: page,
      resource: 'credentials',
      onSuccess: loadCredentialsSuccess,
      onErrorMessage: getIntlMessage('credential.load.error'),
      onLoading,
      disableAppError: true,
      filters: {
        search: {
          selector: getSearch,
        },
        category: {
          skipValue: 'all',
          selector: getCredentialListFilters,
          key: 'category',
        },
        filterAccess: {
          selector: getCredentialListFilters,
          key: 'filter',
        },
        projectId: {
          selector: getCredentialListFilters,
          key: 'projectId',
          skipValue: 'all',
        },
      },
      sort: (state) => getSortingByKey(state, { settingKey: CREDENTIAL_LIST }),
    },
  };
};

export const setModeratedCount = (count) => {
  return {
    type: SET_MODERATED_COUNT,
    count,
  };
};
